import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { animation } from '../constants/animation';
import { getColorNames } from '../constants/background';
import { BLANK } from '../constants/useOptions';
import { getBackground } from '../operators/getBackground';
import { jsx as _jsx } from "react/jsx-runtime";
const AnimatedGradient = styled.div.withConfig({
  displayName: "SkeletonGradient__AnimatedGradient"
})(["display:block;position:absolute;top:0;left:0;right:0;height:100%;transform:translateX(-100%);", " ", ""], ({
  use,
  theme
}) => getBackground({
  use,
  theme
}), ({
  use
}) => use !== BLANK && animation);
export const SkeletonGradient = ({
  use = 'default'
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(View, {
      backgroundColor: getColorNames({
        use
      }).primary,
      inset: "0",
      position: "absolute",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(AnimatedGradient, {
        use: use
      })
    })
  );
};
SkeletonGradient.displayName = 'SkeletonGradient';